const TitleSection = ({ title, description }) => (
  <article className='flex flex-col justify-center items-start mt-24 space-y-8 md:space-y-6'>
    <h1 className='text-subtitle md:text-5xl font-bold'>
      {title}
    </h1>
    <p className='text-neutral-7 text-content leading-normal'>{description}</p>
  </article>
);

export default TitleSection;
